document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var bodyNode = document.body;
  var backgroundNode = document.getElementById('full-bg');
  var searchBackgroundNode = document.getElementById('search-bg');
  var htmlNode = document.querySelector('html');

  // Disable scrolling on body when background is opened
  function disableBodyScroll(mutationList, observer) {
    for (var i = 0; i < mutationList.length; i++) {
      if (mutationList[i].attributeName === 'class' && bodyNode) {
        if (mutationList[i].target.classList.contains('open')) {
          htmlNode.classList.add('overflow-hidden');
        } else {
          htmlNode.classList.remove('overflow-hidden');
        }
      }
    }
  }

  var mutationObserver = new MutationObserver(disableBodyScroll);
  mutationObserver.observe(backgroundNode, { attributes: true });
  mutationObserver.observe(searchBackgroundNode, { attributes: true });
});
